import { Pipe, PipeTransform } from '@angular/core';
import { Params } from '@angular/router';
import { DerivativeType, ISSUER_MAPPING } from '@zero/leverage-products/domain';
import { DerivativeSearchProduct, LeverageProductType } from '@zero/shared/util-models';

@Pipe({
  name: 'trackingQueryParams',
  standalone: true,
})
export class TrackingQueryParamsPipe implements PipeTransform {
  readonly #typeMapping: Record<DerivativeType, string> = {
    discount: 'DISC',
    optionsscheine: 'OS',
    factor: 'FOS',
    knockout: 'KO',
  };

  public transform(
    product: DerivativeSearchProduct,
    location: string,
    positionInList: number,
    derivativeType: DerivativeType,
    leverageProductType: LeverageProductType,
    underlyingIsin: string,
  ): Params {
    const { isin, emittent, leverage } = product;
    const lev = leverage ? `lev${leverage}-` : '';
    const underlying = underlyingIsin ? `-${underlyingIsin}` : '';
    const fzcampaign = this.#max(
      `hebelsuche-${this.#shortenDerivativeType(derivativeType)}${this.#getLeverageProductType(leverageProductType, derivativeType)}-${ISSUER_MAPPING[emittent] ?? emittent}`,
    );
    const fzcontent = this.#max(`${location}-${lev}pos${positionInList}${underlying}`);
    return {
      isin,
      direction: 'buy',
      fzsrc: 'zerocockpit',
      fzmedium: 'web',
      fzcampaign,
      fzterm: isin,
      fzcontent,
    };
  }

  #max(value: string): string {
    return value.substring(0, 50);
  }

  #shortenDerivativeType(derivativeType: DerivativeType): string {
    return this.#typeMapping[derivativeType] ?? '';
  }

  #getLeverageProductType(leverageProductType: LeverageProductType, derivativeType: DerivativeType): string {
    if (derivativeType === 'discount') {
      return '';
    }

    return leverageProductType === LeverageProductType.PUT ? '-Short' : '-Long';
  }
}
